module.exports = __webpack_public_path__ + "static/f-08267242083fa8b1ebd1769ea17c3611.jpg";